module.exports = __webpack_public_path__ + "static/media/star_outer.e955fd98.png";